const styles = {
    content: {
      textAlign: 'center',
      padding: 10
    }
  };
export default styles;


// WEBPACK FOOTER //
// ./src/pages/404/styles/NotFoundPageStyles.js